import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconHeartActiveSvg } from "./IconHeartActiveSvg.mjs";
const IconHeartActive = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconHeartActiveSvg, ...iconProps });
};
export {
  IconHeartActive
};
